var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { margin: "-15px" } }, [
    _c(
      "div",
      {
        staticStyle: {
          padding: "10px",
          height: "calc(100vh - 179px)",
          "overflow-y": "auto",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "financialRef",
            attrs: {
              disabled: _vm.disabled,
              model: _vm.ruleForm,
              "label-position": "top",
              size: "small",
            },
          },
          [
            _c(
              "div",
              [
                _c("div", { staticClass: "title-cmp" }, [
                  _vm._v(_vm._s(_vm.$t("basicData.UnderlyingData"))),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("customerManagements.priceTerms"),
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "billingMethod",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.billingMethod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "billingMethod", $$v)
                                  },
                                  expression: "ruleForm.billingMethod",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.oneParagraph"
                                    ),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.twoParagraph"
                                    ),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.paymentMethod"),
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "settlementMethod",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.settlementMethod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "settlementMethod",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.settlementMethod",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.PeriodicSettlement"
                                    ),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "basicData.RechargeSettlement"
                                    ),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "title-cmp" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customerManagements.VolumeCharging")) +
                      " "
                  ),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.VolumeCharging"
                              ),
                              prop: "useVolumeBilling",
                            },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-color": "#00A551",
                                "inactive-color": "#ff4949",
                                disabled: _vm.disabled,
                              },
                              model: {
                                value: _vm.ruleForm.useVolumeBilling,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "useVolumeBilling",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.useVolumeBilling",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.ruleForm.useVolumeBilling === 1
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "customerManagements.ExpressSmallParcel"
                                  ),
                                  rules: [
                                    {
                                      required:
                                        (_vm.ruleForm.useVolumeBilling === 1 &&
                                          (_vm.ruleForm.largeCalculateBase ===
                                            null ||
                                            _vm.ruleForm.largeCalculateBase ===
                                              "" ||
                                            _vm.ruleForm.largeCalculateBase ===
                                              undefined)) ||
                                        _vm.ruleForm.smallCalculateBase ||
                                        _vm.ruleForm.smallCalculateBase === 0,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      trigger: ["change", "blur"],
                                    },
                                  ],
                                  prop: "smallCalculationMethod",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      clearable: "",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value:
                                        _vm.ruleForm.smallCalculationMethod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "smallCalculationMethod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ruleForm.smallCalculationMethod",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: 0, label: "*" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: 1, label: "/" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  rules: [
                                    {
                                      validator: _vm.validateBase,
                                      trigger: ["change", "blur"],
                                    },
                                  ],
                                  prop: "smallCalculateBase",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-top": "28px",
                                  },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.pleaseInput"
                                    ),
                                    disabled: _vm.disabled,
                                  },
                                  on: { input: _vm.changeSmall },
                                  model: {
                                    value: _vm.ruleForm.smallCalculateBase,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "smallCalculateBase",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.smallCalculateBase",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.ruleForm.useVolumeBilling === 1
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "customerManagements.ExpressLargeParcel"
                                  ),
                                  rules: [
                                    {
                                      required:
                                        (_vm.ruleForm.useVolumeBilling === 1 &&
                                          (_vm.ruleForm.smallCalculateBase ===
                                            null ||
                                            _vm.ruleForm.smallCalculateBase ===
                                              "" ||
                                            _vm.ruleForm.smallCalculateBase ===
                                              undefined)) ||
                                        _vm.ruleForm.largeCalculateBase ||
                                        _vm.ruleForm.largeCalculateBase === 0,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      trigger: ["change", "blur"],
                                    },
                                  ],
                                  prop: "largeCalculationMethod",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      clearable: "",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value:
                                        _vm.ruleForm.largeCalculationMethod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "largeCalculationMethod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ruleForm.largeCalculationMethod",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: 0, label: "*" },
                                    }),
                                    _c("el-option", {
                                      attrs: { value: 1, label: "/" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "flex_item_center",
                            attrs: { span: 19 },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  rules: [
                                    {
                                      validator: _vm.validateBase,
                                      trigger: ["change", "blur"],
                                    },
                                  ],
                                  prop: "largeCalculateBase",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-top": "28px",
                                  },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.pleaseInput"
                                    ),
                                    disabled: _vm.disabled,
                                  },
                                  on: { input: _vm.changeSmall },
                                  model: {
                                    value: _vm.ruleForm.largeCalculateBase,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "largeCalculateBase",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.largeCalculateBase",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "flex_item_center" },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { margin: "0 10px" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "customerManagements.bulkVolumeDiscountFactor"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "QuestionMark",
                                    attrs: { placement: "top" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "customerManagements.dimensionalWeightDiscountNotice"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "customerManagements.finalBillingWeightFormula"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("svg-icon", {
                                      attrs: { "icon-class": "QuestionMark" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("el-switch", {
                                  staticStyle: { margin: "0 10px" },
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                    "active-color": "#00A551",
                                    "inactive-color": "#ff4949",
                                  },
                                  on: { change: _vm.changeLargeVolumeDiscount },
                                  model: {
                                    value: _vm.ruleForm.useLargeVolumeDiscount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "useLargeVolumeDiscount",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "ruleForm.useLargeVolumeDiscount",
                                  },
                                }),
                                _vm.ruleForm.useLargeVolumeDiscount === 1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "20px" },
                                        attrs: {
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t(
                                                "customerManagements.pleaseInput"
                                              ),
                                              trigger: ["change", "blur"],
                                            },
                                            {
                                              type: "integer",
                                              message: _vm.$t(
                                                "customerManagements.integerOnly"
                                              ),
                                              trigger: ["change", "blur"],
                                            },
                                            {
                                              pattern: /^(?:[1-9]\d?|100)$/,
                                              message: _vm.$t(
                                                "customerManagements.integerBetween1And100"
                                              ),
                                              trigger: ["change", "blur"],
                                            },
                                          ],
                                          prop: "largeVolumeDiscountRate",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            maxlength: 3,
                                            placeholder: _vm.$t(
                                              "customerManagements.pleaseInput"
                                            ),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.ruleForm
                                                .largeVolumeDiscountRate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "largeVolumeDiscountRate",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "ruleForm.largeVolumeDiscountRate",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.ruleForm.useLargeVolumeDiscount === 1
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-left": "6px" } },
                                      [_vm._v("%")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "title-cmp" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerManagements.FeeGenerationNode"))
                  ),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.ExpressBusiness"
                              ),
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "expressFeeNode",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                },
                                model: {
                                  value: _vm.ruleForm.expressFeeNode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "expressFeeNode",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.expressFeeNode",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: 1,
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.OrderNode"
                                    ),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  key: 2,
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.PickupNode"
                                    ),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.PickupBusiness"
                              ),
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "collectFeeNode",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                },
                                model: {
                                  value: _vm.ruleForm.collectFeeNode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "collectFeeNode",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.collectFeeNode",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: 1,
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.OrderNode"
                                    ),
                                    value: 0,
                                  },
                                }),
                                _c("el-option", {
                                  key: 2,
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.PickupNode"
                                    ),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "title-cmp" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerManagements.OtherInformation"))
                  ),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.FinancialContactPerson"
                              ),
                              prop: "financeContactsName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "customerManagements.pleaseInput"
                                ),
                              },
                              model: {
                                value: _vm.ruleForm.financeContactsName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "financeContactsName",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.financeContactsName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.FinancialContactPersonPhone"
                              ),
                              rules: [
                                {
                                  required: false,
                                  validator: _vm.checkNumber,
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "financeContactsPhone",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "customerManagements.pleaseInput"
                                ),
                                maxlength: "20",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.financeContactsPhone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "financeContactsPhone",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.financeContactsPhone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.FinancialContactPersonTel"
                              ),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "customerManagements.pleaseInput"
                                ),
                              },
                              model: {
                                value: _vm.ruleForm.financeContactsTel,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "financeContactsTel",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.financeContactsTel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.FinancialContactPersonEmail"
                              ),
                              rules: [
                                {
                                  required: false,
                                  validator: _vm.checkEmail,
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "financeContactsEmail",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "customerManagements.pleaseInput"
                                ),
                              },
                              model: {
                                value: _vm.ruleForm.financeContactsEmail,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "financeContactsEmail",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.financeContactsEmail",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "customerManagements.FinancialContactPersonQQ"
                              ),
                              rules: [
                                {
                                  required: false,
                                  validator: _vm.checkNumber,
                                  trigger: ["change", "blur"],
                                },
                              ],
                              prop: "financeContactsQq",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "customerManagements.pleaseInput"
                                ),
                                maxlength: "11",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.financeContactsQq,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "financeContactsQq",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.financeContactsQq",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _vm.customerType.type === "add" || _vm.customerType.type === "edit"
      ? _c(
          "div",
          {
            staticStyle: {
              "text-align": "right",
              padding: "10px",
              "border-top": "1px solid #ccc",
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permit",
                    rawName: "v-permit:remove",
                    value: "btn:customer-managements:list:financialEdite",
                    expression:
                      "'btn:customer-managements:list:financialEdite'",
                    arg: "remove",
                  },
                ],
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.submit")) + " ")]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.cancelWindow } },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")) + " ")]
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }